import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GOOGLE_SHEET_DATASET_FEATURE_KEY, GoogleSheetIngestState, selectEntities } from './google-sheet.reducer';

export const googleSheetIngestState = createFeatureSelector<GoogleSheetIngestState>(GOOGLE_SHEET_DATASET_FEATURE_KEY);

export const googleSheetIngestEntities = createSelector(
  googleSheetIngestState,
  (state) => state.googleSheetIngestEntities
);

export const googleSheetIngestStateEntities = createSelector(googleSheetIngestEntities, selectEntities);

export const progressToastId = (reportRunToken: string) =>
  createSelector(
    googleSheetIngestStateEntities,
    (googleSheetIngestStateEntities) => googleSheetIngestStateEntities?.[reportRunToken]?.progressToastId
  );
